import { translate } from 'containers/services/translate';
import { DOCUMENT_STATUS } from 'containers/ManagerDocumentsPage/constants';
import messages from 'containers/ManagerDocumentsPage/messages';

export const formatStatus = (status: string, props: any): string => {
  let translatedStatus;
  switch (status) {
    case DOCUMENT_STATUS.VALIDATED:
      translatedStatus = messages.validated;
      break;
    case DOCUMENT_STATUS.REJECTED:
      translatedStatus = messages.rejected;
      break;
    case DOCUMENT_STATUS.TO_VALIDATE:
      translatedStatus = messages.toValidate;
      break;
  }
  return translate(translatedStatus, props);
};
